<template>
    <div>
        <div class="file-type-selector">
            <label for="">Select Folder</label>
            <select class="form-control" v-model="tag" @change="handleTagChange">
                <option v-for="option in tagOptions" :value="option.value" v-if="option.value !== 'updates' && option.value !== 'offering-doc' && option.value !== 'tax-form' && option.value !== 'subscription' && option.value !== 'updates'">
                    {{ option.text }}
                <!--option.value === 'om' ? 'Offering Documents' : (option.value === 'collateral' ? 'Marketing Materials' : (option.value === 'rna' ? 'More Information' : option.text))-->
                </option>

            </select>

        </div> 

        <!-- New custom folder modal -->
        <div class="modal" tabindex="-1" role="dialog" v-if="showCustomFolderPopup" style="display: block; position: fixed; z-index: 999; left: 0; top: 0; width: 100%; height: 100%; overflow: auto; background-color: rgba(0,0,0,0.4);">

            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Create Custom Folder</h5>
                        <button type="button" class="close" @click="closeCustomFolderPopup">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <input type="text" v-model="customFolderName" class="form-control" placeholder="Enter folder name">
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="closeCustomFolderPopup">Cancel</button>
                        <button type="button" class="btn btn-primary" @click="submitCustomFolder">Create</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="uploader margin-bottom-40">
            <label for="">Uploader</label>
            <file-uploader :params="uploaderParams" @fileUploaded="fileUploaded"></file-uploader>

        </div>

        <table class="table">
            <thead>
                <tr>
                    <th>Folder</th>
                    <th>Order</th>
                    <th>File Name</th>
                    <th>Description</th>
                    <th>Visibility</th>
                </tr>
            </thead>
            <tr v-for="doc in sortedDocs" v-if="doc.tag !== 'updates' && doc.tag !== 'offering-doc' && doc.is_personal === 0">
                <td>{{ doc.tag === 'om' ? 'Offering Documents' : (doc.tag === 'collateral' ? 'Marketing Materials' : (doc.tag === 'rna' ? 'More Information' : doc.tag)) }}</td>
                <td>{{ doc.order }}</td>
                <td>{{ doc.name }}</td>
                <td>{{ doc.description }}</td>
                <td>{{ doc.is_read_only ? 'Read-Only' : '' }}</td>
                <td>
                    <a :href="doc.pretty_url" style="margin-right: 10px;">
                        View
                    </a>
                </td>
                <td>
                    <a :href="`/admin/${activeEmd.slug}/offerings/${offering.id}/docs/${doc.id}/edit`" style="margin-right: 10px;">
                        edit
                    </a>
                </td>
                <td>
                    <a @click="deleteDocument($event,doc.id)">
                        delete
                    </a>
                </td>
            </tr>
        </table>
        <confirm-modal
            :show-confirm="showConfirmDelete"
            :confirm-message="confirmDeleteMessage"
            @ok="confirmDelete"
            @cancel="cancelDelete"
        ></confirm-modal>
    </div>
</template>

<script>
import FileUploader from '../components/FileUploader.vue';
import ConfirmModal from "../components/ConfirmModal";
export default {
    data() {
        return {
            docsList: window.docsList,
            docs: window.documents || [],
            offering: window.offering,
            activeEmd: window.activeEmd,
            tag: 'om',
            showCustomFolderPopup: false,
            customFolderName: '',
            staticTagOptions: [
                {value: 'om', text: 'Offering Documents'},
                {value: 'collateral', text: 'Marketing Materials'},
                {value: 'rna', text: 'More Information'},
            ],
            dynamicTagOptions: [],
            customFolderOption: {value: 'custom_folder', text: 'Create Custom Folder'},
            //uploadKey: 0,
            showConfirmDelete: false,
            confirmDeleteMessage: 'Are you sure you want to delete this document?',
            documentToDelete: null,
        }
    },
    computed: {
        uploaderParams() {
            return {
                offeringId: offering.id, 
                is_read_only: false, 
                order: 1,
                tag: this.tag,
                investments: '',
                is_personal: false,
            }
        },
        tagOptions() {
            return [...this.staticTagOptions, ...this.dynamicTagOptions, this.customFolderOption];
        },
        sortedDocs() {
            return [...this.docs].sort((a, b) => {
                // First, compare by tag.
                const tagComparison = a.tag.localeCompare(b.tag);
                if (tagComparison !== 0) {
                    return tagComparison;
                }

                // If the tags are the same, then compare by order.
                return a.order - b.order;
            });
        },
        docLinks() {
        const links = {};
        this.docs.forEach(doc => {
            links[doc.filepath] = doc.upload ? doc.upload.prettyRoute() : '';
        });
        return links;
    }
    },
    events: {
        
    },
    components: {
        FileUploader,
        ConfirmModal,
    },
    methods: {
        fileUploaded(doc) {
            //this.docs.push(doc);
            window.location.href = `/admin/${activeEmd.slug}/offerings/${offering.id}/docs/${doc.id}/create/edit`
        },
        handleTagChange() {
            if (this.tag === 'custom_folder') {
                this.showCustomFolderPopup = true;
            }
        },
        closeCustomFolderPopup() {
            this.showCustomFolderPopup = false;
        },
        submitCustomFolder() {
            if (this.customFolderName) {
                // Add new option
                this.dynamicTagOptions.push({value: this.customFolderName, text: this.customFolderName});

                // Set the new option as selected
                this.tag = this.customFolderName;

                // Clear the input
                this.customFolderName = '';

                // Close the popup
                this.showCustomFolderPopup = false;
                    } else {
                        alert('Please enter a folder name');
                    }
        },
        
         deleteDocument(event, id) {
            this.documentToDelete = id; // Store the ID of the document to delete
            this.showConfirmDelete = true; // Show the confirmation modal
        },
        confirmDelete() {
            if (this.documentToDelete) {
                this.showConfirmDelete = false;
                const documentToDelete = this.documentToDelete;
    
                const deleteUrl = `/admin/${this.activeEmd.slug}/offerings/${this.offering.id}/docs/${this.documentToDelete}/delete`;

                fetch(deleteUrl, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json', 
                    }
                })
                .then(response => {
                    if (response.ok) {
                        console.log(`Document with ID ${documentToDelete} deleted successfully`);

                        this.docs = this.docs.filter(doc => doc.id !== documentToDelete);
                    } else {
                        console.error('Error deleting document:', response.statusText);
                    }
                })
                .catch(error => {
                    console.error('Error deleting document:', error);
                });

                this.documentToDelete = null;
            } else {
                console.log('No document to delete.');
            }
        },
        cancelDelete() {
            this.showConfirmDelete = false;
            this.documentToDelete = null;
        },
    },
    mounted() {
    const uniqueTags = [...new Set(this.docs.map(doc => doc.tag))];
    const staticTagValues = this.staticTagOptions.map(option => option.value); // array of static tag values

    uniqueTags
        .filter(tag => !staticTagValues.includes(tag)) // exclude static tags
        .forEach(tag => {
            this.dynamicTagOptions.push({value: tag, text: tag});
        });

    }
}
</script>
